//-----------------------------------------------------------------------
// <copyright file="dashboard.component.ts" company="LGT India">
//     Author: vanaraj
//     Copyright (c) LGT India. All rights reserved.
// </copyright>
//-----------------------------------------------------------------------
import { Component, OnInit } from "@angular/core";
import { AuthService } from "../services/auth.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
})
export class DashboardComponent implements OnInit {
  constructor(private auth: AuthService, private router: Router) {}
  user = { localId: "someid", displayName: "somename" };
  ngOnInit(): void {
    if (this.auth.isAuthenticated()) {
      // call user details service
      this.auth.detail().subscribe({
        next: (data) => {
          this.user.localId = data.users[0].localId;
          this.user.displayName = data.users[0].displayName;
        },
      });
    }
  }
  goToHomePage(): void {
    this.router.navigate(["/dashboard"]); // Navigate to the home page
  }
}
